// src/redux/vendorState.js

export const initialState = {
  organizationId: null,
  communityId: null,
};
